export default __webpack_public_path__ + "static/bldc-5010-8b9d4a3536446e22fcc4c2241df91eb1.jpg";